import store from '@/store';
import randomColor from '@/shared/utils/random-color';

export default class NewChatvisorEvent {
  constructor(message) {
    console.log('[NewChatvisorEvent]', { message });
    const { supervisorId, chatvisorUser, supervisorName, from } = message;
    const { chats } = store.state.chatVisor;
    const notExistChatVisor =
      chats.findIndex(
        (chatVisor) => chatVisor.chatvisorUser === chatvisorUser,
      ) === -1;

    if (notExistChatVisor) {
      const newChatVisor = {
        chatvisorUser,
        supervisorId,
        supervisor: {
          identifier: supervisorId,
          name: supervisorName,
        },
        messages: [],
        avatarColor: randomColor(),
        from,
      };

      store.dispatch('chatVisor/newChatvisor', newChatVisor);
    }
  }
}
